<div class="bv-send-details" [formGroup]="sendDetailsForm">
  <bit-form-field class="bv-send-field">
    <bit-label>{{ "name" | i18n }}</bit-label>
    <input bitInput type="text" formControlName="name" [readonly]="!editing()" />
    @if (editing()) {
      <bit-hint>{{ "bvSendNameHint" | i18n }}</bit-hint>
    }
  </bit-form-field>

  <div class="bv-send-type">
    <p class="bv-send-type__label">{{ "bvSendTypeQuestion" | i18n }}</p>
    <div class="bv-send-type__options">
      <label
        class="bv-send-type__option"
        [class.bv-send-type__option--active]="isSendType(SendType.File)"
      >
        <input type="radio" name="sendTypeDisplay" disabled [checked]="isSendType(SendType.File)" />
        <span>{{ "sendTypeFile" | i18n }}</span>
      </label>
      <label
        class="bv-send-type__option"
        [class.bv-send-type__option--active]="isSendType(SendType.Text)"
      >
        <input type="radio" name="sendTypeDisplay" disabled [checked]="isSendType(SendType.Text)" />
        <span>{{ "sendTypeText" | i18n }}</span>
      </label>
    </div>
  </div>

  @if (sendFormService.sendFormConfig.sendType === SendType.Text) {
    <app-bv-send-text-details [editing]="editing()"></app-bv-send-text-details>
  }
  @if (sendFormService.sendFormConfig.sendType === SendType.File) {
    <app-bv-send-file-details [editing]="editing()"></app-bv-send-file-details>
  }

  @if (editing()) {
    <div class="bv-send-share">
      <h3 class="bv-send-share__title">{{ "share" | i18n }}</h3>
      <bit-form-control>
        <input
          bitCheckbox
          type="checkbox"
          [checked]="copyLinkOnSave()"
          (change)="onCopyLinkOnSaveChange($event)"
        />
        <bit-label>{{ "bvCopySendLinkOnSave" | i18n }}</bit-label>
      </bit-form-control>
    </div>
  }

  <div class="bv-send-options-panel">
    <button type="button" class="bv-send-options-panel__toggle" (click)="toggleOptions()">
      @if (optionsExpanded()) {
        <span
          class="bv-send-options-panel__chevron bv-send-options-panel__chevron--expanded"
          aria-hidden="true"
        ></span>
      } @else {
        <span class="bv-send-options-panel__chevron-text" aria-hidden="true">&rsaquo;</span>
      }
      <span>{{ "options" | i18n }}</span>
    </button>

    @if (optionsExpanded()) {
      <div class="bv-send-options-panel__body">
        <div class="bv-send-options-panel__dates">
          <bit-form-field class="bv-send-field">
            <bit-label>{{ "deletionDate" | i18n }}</bit-label>
            @if (!editing()) {
              <input
                bitInput
                type="text"
                [value]="sendFormService.originalSendView()?.deletionDate | date: 'short'"
                readonly
              />
            } @else {
              <bit-select
                id="deletionDate"
                name="SelectedDeletionDatePreset"
                formControlName="selectedDeletionDatePreset"
              >
                @for (o of datePresetOptions; track o.label) {
                  <bit-option [value]="o.value" [label]="o.label"></bit-option>
                }
              </bit-select>
            }
            @if (editing() && !policyDeletionHoursOrgName) {
              <bit-hint>{{ "deletionDateDescV2" | i18n }}</bit-hint>
            }
            @if (editing() && policyDeletionHoursOrgName) {
              <bit-hint>{{
                "sendDeletionDateSetByOrg" | i18n: policyDeletionHoursOrgName
              }}</bit-hint>
            }
          </bit-form-field>

          <bit-form-field class="bv-send-field">
            <bit-label>{{ "expirationDate" | i18n }}</bit-label>
            @if (!editing()) {
              <input bitInput type="text" [value]="expirationDateDisplay" readonly />
            } @else {
              <bit-select
                id="expirationDate"
                name="SelectedExpirationDatePreset"
                [formControl]="selectedExpirationDatePresetControl"
              >
                @for (o of expirationDatePresetOptions(); track o.label) {
                  <bit-option [value]="o.value" [label]="o.label"></bit-option>
                }
              </bit-select>
            }
            @if (editing()) {
              <bit-hint>{{ "expirationDateDesc" | i18n }}</bit-hint>
            }
          </bit-form-field>
        </div>

        @if (
          editing() &&
          (availableAuthTypes$ | async)?.length > 1 &&
          sendDetailsForm.get("authType").value === AuthType.Email
        ) {
          <bit-form-field class="bv-send-field">
            <bit-label>{{ "whoCanView" | i18n }}</bit-label>
            <bit-select formControlName="authType">
              @for (option of availableAuthTypes$ | async; track option.value) {
                <bit-option [value]="option.value" [label]="option.nameKey | i18n"></bit-option>
              }
            </bit-select>
          </bit-form-field>

          <bit-form-field disableMargin class="bv-send-field">
            <bit-label>{{ "emails" | i18n }}</bit-label>
            <textarea
              bitInput
              formControlName="emails"
              rows="3"
              maxlength="2500"
              [placeholder]="'emailPlaceholderMultiple' | i18n"
            ></textarea>
            <bit-hint>{{ "enterMultipleEmailsSeparatedByComma" | i18n }}</bit-hint>
          </bit-form-field>
        }

        @if (editing()) {
          <bit-form-field class="bv-send-field bv-send-field--password">
            <bit-label>{{ "password" | i18n }}</bit-label>
            <input
              bitInput
              type="password"
              formControlName="password"
              (input)="onPasswordInput()"
            />
            <div bitSuffix ngProjectAs="[bitSuffix]" class="tw-flex tw-items-center">
              @if (!originalHadPassword) {
                <button
                  type="button"
                  bitIconButton
                  size="small"
                  bitPasswordInputToggle
                  [label]="'toggleVisibility' | i18n"
                ></button>
              }
            </div>
            <bit-hint>{{ "bvSendPasswordHint" | i18n }}</bit-hint>
          </bit-form-field>
        }

        <app-bv-send-options [editing]="editing()"></app-bv-send-options>

        <div class="bv-send-bottom-checkboxes">
          @if (sendOptionsComponent()?.hideEmailVisible()) {
            <bit-form-control
              class="bv-send-checkbox"
              [formGroup]="sendOptionsComponent()!.sendOptionsForm"
            >
              <input bitCheckbox type="checkbox" formControlName="hideEmail" />
              <bit-label>{{ "hideMyEmail" | i18n }}</bit-label>
            </bit-form-control>
          }

          @if (editing()) {
            <bit-form-control class="bv-send-checkbox">
              <input
                bitCheckbox
                type="checkbox"
                [checked]="deactivateSend()"
                (change)="onDeactivateSendChange($event)"
              />
              <bit-label>{{ "bvDeactivateSend" | i18n }}</bit-label>
            </bit-form-control>
          }
        </div>
      </div>
    }
  </div>
</div>
